var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Outlet, ScrollRestoration, useLocation } from 'react-router';
import { AppProvider, useAppContext } from './AppContext';
import { AuthProvider, useAuthContext } from './AuthContext';
import { TWMergeProvider } from './TWMergeContext';
import { SkipLink } from './components/global/misc/Skipnav/Skipnav';
import Snackbar from './components/global/misc/Snackbar';
import Footer from './components/navigation/Footer';
import Header from './components/navigation/Header';
import { getLocalStorageItemValue, setLocalStorageItem } from '@utils/local_storage_utils';
import { UI_FLAGS } from '@variables';
var DEFAULT_PAGE_TITLE = 'Fresh dog food, delivered | Nom Nom';
var HIDE_MARKETING_BANNER_EXPIRE_DAYS = 30;
var RootContainer = function (_a) {
    var children = _a.children;
    var isLoggedIn = useAuthContext().isLoggedIn;
    var location = useLocation();
    var _b = useAppContext(), headerBackgroundColor = _b.headerBackgroundColor, setHeaderBackgroundColor = _b.setHeaderBackgroundColor;
    var showMarketingBanner = !getLocalStorageItemValue(UI_FLAGS.HIDE_MARKETING_BANNER) && !isLoggedIn;
    useEffect(function () {
        var routeHeaderBgColorMap = {
            '': 'transparent',
            '/how-it-works': 'bone',
        };
        var pathName = location.pathname.replace(/\/$/, '');
        var newHeaderBackgroundColor = routeHeaderBgColorMap[pathName] || 'beige';
        setHeaderBackgroundColor(newHeaderBackgroundColor);
    }, [location.pathname, setHeaderBackgroundColor]);
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("title", { children: DEFAULT_PAGE_TITLE }) }), _jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(SkipLink, {}), showMarketingBanner && (_jsx("div", __assign({ className: "relative" }, { children: _jsx(Snackbar, { url: "/profile", text: "Get 50% Off Your First Order", onClose: function () {
                                return setLocalStorageItem(UI_FLAGS.HIDE_MARKETING_BANNER, true, HIDE_MARKETING_BANNER_EXPIRE_DAYS);
                            } }) }))), _jsx(Header, { backgroundColor: headerBackgroundColor, isSearchEnabled: false, loggedIn: isLoggedIn }), _jsxs("div", __assign({ className: "mx-auto my-0 flex flex-col min-h-screen w-full relative" }, { children: [_jsx("div", { id: "nav-shadow-overlay", className: "absolute bg-[rgba(0,0,0,0.1)] top-0 z-20 left-0 w-full h-full\n            pointer-events-none transition-opacity duration-[300ms] delay-200 opacity-0" }), _jsx("div", { children: children }), _jsx(Footer, {})] }))] }))] }));
};
var RootLayout = function () {
    return (_jsx(HelmetProvider, { children: _jsx(AppProvider, { children: _jsx(AuthProvider, { children: _jsx(TWMergeProvider, { children: _jsxs(RootContainer, { children: [_jsx(ScrollRestoration, {}), _jsx(Outlet, {})] }) }) }) }) }));
};
export { RootLayout as default, RootContainer };
